module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "pg-boilerplate"
  }, [_c('h2', {
    staticClass: "nobreak",
    attrs: {
      "id": "pgepubid00013"
    }
  }, [_c('a', {
    attrs: {
      "id": "I"
    }
  }, [_vm._v("I")]), _c('br', {
    staticClass: "calibre4"
  }), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("KIT CARSON TO THE RESCUE")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("It was the middle of November, 1840; and across\nthe sandy face of southwestern Kansas was toiling,\noutward bound from Missouri, a Santa Fé caravan:\nfifty-two huge, creaking canvas-topped wagons, drawn\neach by six or eight span of mules or yoke of oxen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("In this day the so-called foreign government of\nMexico extended north through New Mexico to the\nArkansas River in Colorado and southwestern Kansas.\nThe United States stopped at the Rocky Mountains;\nand, moreover, from Missouri to the Rockies\nall was “Indian Country” and the “Great American\nDesert.” From Missouri extended two long roads\nor trails, separating like a “V” with its point near\npresent Kansas City. Up the Platte River, for the\nNorthwest, ran the old trappers’ and fur-traders’ trail,\nnow being made the Oregon Trail of emigrants. Up\nthe Arkansas River, for the Southwest, ran the trail\nof the Santa Fé caravans. The desolate, unimproved"), _c('span', {
    attrs: {
      "id": "pgepubid00014",
      "title": "[18]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_18",
      "title": "[18]"
    }
  })]), _vm._v("\nGreat American Desert was like a sea; and across this\nsea sailed, spring and fall, upon an 800 mile voyage,\nfleets of American wagons, to trade with the capital\nof northern Mexico.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("They took out cargoes of calico, powder, lead,\nflour, shoes, and such American products; they brought\nback, at profit in money and at loss in life, cargoes of\nfurs, hides, gold, gay blankets and such Mexican\nproducts.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("This caravan of November, 1840, with its fifty-two\nwagons and harnessed teams, had at the beginning\nof the journey stretched out in a line almost a mile\nof length. Each wagon had a teamster. Some of the\nteamsters straddled the near animal of the wheel\nspan (the span next to the wagon); others, in their\nboots and flannel shirts and broad hats, walked beside\nthe wagon; horsemen, escort to the wagon-captain,\nwho was the boss of the train, led the march, reconnoitering\nahead; other horsemen paced at right and\nleft; and at the rear of all, upon an old mule, driving\na collection of loose horses and mules, rode a ragged\nlittle boy—Oliver Wiggins.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("This was Oliver’s place—in the dust, at the tail of\nthe long caravan. His duty was to herd the “cavvy,”\nas was styled for short the "), _c('i', {
    staticClass: "calibre9",
    attrs: {
      "xml:lang": "es"
    }
  }, [_vm._v("caballada")]), _vm._v(" (Spanish for\nhorse-herd). His pay was five dollars a month, and\nthe fun and the glory, and the work, of fifty days’\ntravel, at the rate of fifteen miles a day, across the\nplains of sand and sage, buffalo and antelope, hunger"), _c('span', {
    attrs: {
      "id": "pgepubid00015",
      "title": "[19]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_19",
      "title": "[19]"
    }
  })]), _vm._v("\nand thirst, storm and Indians, to strange far-off\nSanta Fé.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("At first the march had been very pleasant. The\ncaravan sometimes had spread out over the prairie in\nformation of four abreast. By day the teamsters had\nsung and cracked their long whips, beside the wagons;\nby night they had sung and told stories, beside the\ncamp-fires. Everybody had been happy. But within\nthe last two days the atmosphere had changed; for\nthere had come riding fast, on the homeward way\nfrom Mexico, two traders, and had left the word,\nwith the captain:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“Watch sharp! The Kiowas are out!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("That was enough. Quickly through the caravan\nspread the news—“"), _c('span', {
    staticClass: "smcap1"
  }, [_vm._v("The Kiowas are out!")]), _vm._v("” All\ncarelessness, all singing, ceased; and the order of\nmarch was made double file or two abreast, so that in\ncase of attack the wagons could swing to right and\nleft and quickly join in a great circle.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("The Kiowas! The fiercest fighting Indians of the\nSouthwest plains were they, outrivalled by neither\nPawnee nor Comanche. Their name was terrible to\nthe Santa Fé traders. Their range was southwestern\nKansas and southeastern Colorado, thence south into\nthe dread Comanche country below the Arkansas.\nWhen the caravan had left Missouri, the Kiowas\nwere said to be at peace; but now they were said, on\ngood authority, to be "), _c('em', {
    staticClass: "calibre9"
  }, [_vm._v("not")]), _vm._v(" at peace, and well might\nWagon-Captain Blunt worry. He had a lot of green"), _c('span', {
    attrs: {
      "id": "pgepubid00016",
      "title": "[20]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_20",
      "title": "[20]"
    }
  })]), _vm._v("\nteamsters, poorly armed with old smooth-bore yagers;\nand whether, if given time to form a circle of wagons,\nthey could beat off the painted warriors, he did not\nknow.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("Holding the rear of all, boy Oliver Wiggins, aged\nthirteen, left to the dust and the shuffling loose stock\n(defenseless beasts, a prize for the Indians), also well\nmight worry. He wished now that he had not run away\nfrom home; and he began to wonder whether, after all,\nhis pistol, about the size of the palm of his hand, was\nlarge enough. This pistol had seemed to him weapon\nin plenty for fighting Indians, in Missouri; but the\nfarther from Missouri he journeyed, and the more\nstories he heard, the smaller the pistol grew.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("Here in southwestern Kansas of to-day the Santa\nFé Trail veered south, beyond the Great Bend of the\nriver, to cross and to head for the Cimarron Desert\nand for New Mexico. This, the Crossing of the Arkansas,\nwas half way to Santa Fé; but the half already\ncovered was the easy half, the half to come was the\ndry, thirsty half, and the Kiowa and Comanche half.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("Through the shallow water and the quick-sands\nforged the wagons of the Blunt caravan, upon the\nfarther bank to halt, for camp and to fill the water-casks.\nThe sun was low and red in the west, the long,\nhigh white-hooded wagons had been parked in the\ncustomary circle, outside the circle camp-fires were\ncurling, pots were bubbling, meat was hissing, and\nbefore each camp tethered animals were grazing; sentries"), _c('span', {
    attrs: {
      "id": "pgepubid00017",
      "title": "[21]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_21",
      "title": "[21]"
    }
  })]), _vm._v("\nhad been posted, and boy Oliver, hungry and\ngrimy, was guarding his browsing cavvy, when a\nsudden commotion struck the peaceful scene. A sentinel\nupon a sand-hill fired his gun to signal “Injuns!\nInjuns!” and rushed like wild-fire the word. Every\nteamster sprang to round up his picketed team, or to\nhelp collect the oxen; the sentries came in at a gallop;\nand men sped to help Oliver with the cavvy. Through\nthe opening left in the circle of wagons poured men\nand animals, from outside to inside. And against the\nsunset glow could be descried a long file of black\nmounted figures, approaching at rapid trot.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("However, Captain Blunt, viewing them by spyglass,\nshouted thankfully:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“Not Injuns, men! Whites! Look like traders.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("Whereupon a sigh of relief swept the tense cordon.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("The cordon did not dare yet to open out again;\nnevertheless, as the riders across the rolling sand-hills\nneared, they were seen by the naked eye to be whites\nindeed. They resolved into a double file of horsemen:\ntrapper-clad in fringed buckskin shirts and leggins, in\nbroad-brimmed hats, in moccasins, and every man carried\nacross his saddle-horn a tremendously long rifle.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“Mountain-men! Trappers!” announced Teamster\n“Dutch” Jake, in Oliver’s hearing. “Now if we\nonly had "), _c('em', {
    staticClass: "calibre9"
  }, [_vm._v("them")]), _vm._v(" with us——!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“They’re the chaps to make the Injuns stand\n’round,” agreed another. And many a head nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("The cavalcade was within gun-shot. A man riding"), _c('span', {
    attrs: {
      "id": "pgepubid00018",
      "title": "[22]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_22",
      "title": "[22]"
    }
  })]), _vm._v("\nalone was leader; and as on they came, at the steady,\nfast “rack” or single-foot, straight for the camp, he\nheld up his hand, palm outward, in a peace sign.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“High jinks! I know that man!” exclaimed\n“Dutch” Jake. And he added: “If it only be, now.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("Captain Blunt and two or three of his lieutenants,\ncarrying their guns, walked outside a few steps to meet\nthis leader. The conversation was wafted clearly\nthrough the still, dry air, while all the camp listened.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“Howdy?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“Howdy?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“Who’s yore captain?” This from the horseman.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“I’m the captain.” This from Blunt.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“Wall, my name’s "), _c('a', {
    attrs: {
      "href": "#/Text/Section0007#i_fp022"
    }
  }, [_vm._v("Kit Carson")]), _vm._v(". We’ve come over\nfrom Touse to ride the trail through Kiowa country,\nwith anybody that needs us. S’pose you know the\nKiowas air bad?”")]), _vm._v(" "), _c('div', {
    staticClass: "figcenter3"
  }, [_c('a', {
    attrs: {
      "id": "i_fp022"
    }
  }, [_c('img', {
    staticClass: "calibre10",
    attrs: {
      "alt": "",
      "id": "id-30441713018168191",
      "src": "Images/img0001.jpg",
      "title": ""
    }
  })]), _c('br', {
    staticClass: "calibre4"
  }), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0007#Page_22"
    }
  }, [_vm._v("CHRISTOPHER CARSON")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“So we’ve heard. And we’re mighty glad to see\nyou, Mr. Carson,” declared Captain Blunt, reaching\nup and shaking hands heartily.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("Kit Carson! Kit Carson! The name passed from\nlip to lip around the wagon cordon; and a hundred\neyes were fastened eagerly upon the spot where now\nthis leader squatted beside a fire, as guest and counsellor\nof Captain Blunt.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("The others in the party (which numbered about\nforty) had unsaddled like lightning, had turned their\nhorses out, under a guard, and starting fires or gnawing\nstrips of jerked meat were making their own camp"), _c('span', {
    attrs: {
      "id": "pgepubid00019",
      "title": "[23]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_23",
      "title": "[23]"
    }
  })]), _vm._v("\nnear at hand. Darkly tanned, long-haired, broad-shouldered\nmen were they, the majority heavily\nbearded. They moved lithely in moccasins, their buckskin\nsuits were patched and stained, they scarcely\nstirred without rifle in hollow of arm, their belts bore\npistol or pair of pistols, and knife; their talk was a\ncurious jargon, but very expressive, and they themselves\nwere exceedingly business-like.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("But the wonderful Kit Carson, famous hunter and\nIndian fighter—was that really he? Of course, everybody\non the Santa Fé Trail knew about Kit Carson,\nthe free-trapper and captain of trappers, who as merely\na boy had made such a name for himself in the mountains\nand who recently had come out of them, to live\nat "), _c('span', {
    attrs: {
      "xml:lang": "es"
    }
  }, [_vm._v("Fernandez de Taos")]), _vm._v(" and to supply meat for Bent’s\nFort, north. Ere leaving the Missouri frontier little\nOliver had heard of Kit Carson as though he were ten\nfeet tall and four feet wide, and bore a pine-tree for a\nclub; but now little Oliver beheld an ordinary-looking\nperson, not much taller than himself and not nearly\nso tall as many of the other trappers; with wiry body,\nbandy legs, flat features, and a voice so ridiculously\nlow that his present conversation with Captain Blunt\ndid not carry beyond the camp-fire light.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("Murmured comment by teamsters, here and there\namong the wagons, showed to Oliver that he was not\nalone in his disappointment.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“That’s Kit Carson, is it?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“That leetle feller, with the captain yon?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_c('span', {
    attrs: {
      "id": "pgepubid00020",
      "title": "[24]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_24",
      "title": "[24]"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“Wall, naow, I thought Kit Carson war some\npunkins!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“A big Injun’s liable to pick him right up!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“Whar’s his whiskers?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("But Dan Matthews, Captain Blunt’s first lieutenant,\ncame hurrying, from point to point in the circle.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“Turn out your critters, men; and you guards\npost yourselves as before. Lively. There’s likely no\ndanger to-night, Carson says; but keep your eyes and\nears open, jest the same.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“Is that thar reely Kit Carson—that leetle chap?”\nqueried Teamster Henry, as the camp bustled to resume\nits routine.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("Henry grunted.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“Wall, he’s the smallest pea for the amount of pod\never "), _c('em', {
    staticClass: "calibre9"
  }, [_vm._v("I")]), _vm._v(" see!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“Don’t you be fooled, Henry,” retorted Lieutenant\nMatthews. “You wait a bit, and if you don’t find\nthat he’s got the biggest "), _c('em', {
    staticClass: "calibre9"
  }, [_vm._v("do")]), _vm._v(" for the size of his "), _c('em', {
    staticClass: "calibre9"
  }, [_vm._v("tell")]), _vm._v("\nthat ever you ran across, I’ll eat my hat.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“That’s right,” affirmed “Dutch” Jake, overhearing.\n“Brag’s a good dog but he won’t fight; an’\nyou mustn’t jedge a race-hoss by the color of his hide.\nYou’re seeing one Kit Carson, a gentle-speaking,\nmild-appearing, sort o’ nincompoop who you might\nthink didn’t know beans. But there’s another Kit\nCarson, half hoss an’ half alligator, as they say on the\nMississippi, or half grizzly b’ar an’ half charging elk,"), _c('span', {
    attrs: {
      "id": "pgepubid00021",
      "title": "[25]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_25",
      "title": "[25]"
    }
  })]), _vm._v("\nas "), _c('em', {
    staticClass: "calibre9"
  }, [_vm._v("I")]), _vm._v(" say; an’ I reckon you’ll see him, too, ’fore we’re\nthrough Injun country.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("These words of “Dutch” Jake impressed Oliver\ndeeply, for Jake spoke as if he knew. At any rate,\n’twas pleasant to have the reinforcements: to watch\ntheir easy figures, to hear their voices, to stroll through\ntheir camp and catch their conversation, to note their\nfringed, beaded clothing, their worn weapons, and\ntheir wildly shaggy faces; and to feel their presence, so\nhandy, when in the darkness the fires died and both\ncamps went to sleep.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("All the next day the march proceeded, southward\nfrom the Arkansas, amidst sand hills and sparse vegetation.\nThe trappers from Taos rode in a line along\neither side of the train, with scouts ahead and out\nupon the flanks. The men of the train laughed and\ntalked, bantering back and forth. And behind, in the\nreek of the procession, boy Oliver, ragged and upon his\nold mule, driving the cavvy, strained eye and ear to\nkeep tab upon what was being done and said. At the\nnoon camp he had opportunity to scan, close by daylight,\nKit Carson again.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("Kit Carson proved to have a square face, rugged\nand weather-beaten, with sandy moustache, and\nframed in long brown hair combed smoothly down behind\nthe ears. His cheek-bones were high, somewhat\nIndian-like, his forehead was high and full, his mouth\nstraight and his chin firm. His most remarkable\nfeature was his eyes—wide apart, level-set, and of an"), _c('span', {
    attrs: {
      "id": "pgepubid00022",
      "title": "[26]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_26",
      "title": "[26]"
    }
  })]), _vm._v("\nintense steely gray that fairly bored a hole where they\nlooked. His movements were quick and sure; and\nhow he stuck to a horse!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("Oliver the more believed that “Dutch” Jake and\nLieutenant Matthews both knew better than Henry\nand the other grumblers. Something about Kit\nCarson said so.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("Despite the rough joking, the march was an earnest\none. No straggling was permitted, to shoot antelope\nor elk. Yet the day was not uneventful, for once\na great brown-bearded man—his beard reaching\nalmost to his belt—who was Solomon Silver, a Carson\nman, dropping back, rode beside the cavvy until,\nhaving good-naturedly eyed Oliver, he joined him, to\nquery, perhaps as a joke:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“Wall, boy; what’d ye reckon to do if the Injuns\ncome down sudden?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“I’d fight ’em,” said Oliver, bravely. “Here’s my\npistol. See?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“Haw! Haw!” boomed Sol Silver the trapper,\nin a rousing laugh; and behind his beard he chuckled.\n“That’s right, boy. Let’s see that shooting-iron o’\nyorn,” and he laid it in the palm of his scarred hand.\n“No use o’ Kit an’ us a-riding the trail, when this air\nriding it too. I’ll tell him. ’Spec’ if you shoot an\nInjun with this, son, an’ he gets to find out, he’d be\npowerful mad at ye! But thar, boy; do yore best.\nHyar’s ’nother kind o’ pistol. Ever see one?” And\nhe pulled it from his buffalo-hide belt.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_c('span', {
    attrs: {
      "id": "pgepubid00023",
      "title": "[27]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_27",
      "title": "[27]"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“No,” confessed Oliver.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("It was an odd-looking pistol, with long barrel and\na round bulge between barrel and stock.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“That air a pistol to shoot six times without reloading,”\ndeclared Sol. “It has one barrel an’ six\nchambers, in this cylinder; the barrel stays put, but the\ncylinder turns ’round, with a fresh load ready, whenever\ntrigger air pulled. Wagh! It air made by a man\nnamed Colt, in the States; it air called Colt, but it air\na full-size hoss.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“Have you all got them?” asked Oliver.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“All we Carson men have ’em, an’ percussion-cap\nrifles, to boot. When Kit Carson goes into a fight, he\ngoes in to win, an’ the best weapons air none too good\nfor his men. We air Carson men.” Sol proclaimed\nthis with a certain degree of pride.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“Will the Kiowas attack us, sure?” invited\nOliver.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“’Bout to-morrow, Kit thinks. When they do,\nyou give us fellows a chance ’fore you open up with\nyore battery an’ take all the scalps.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("But Oliver suspected that Sol was joking again.\nStill, he liked this jovial, burly Sol Silver, and hoped\nthat he "), _c('em', {
    staticClass: "calibre9"
  }, [_vm._v("would")]), _vm._v(" tell Kit Carson.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("Nothing especial happened this night in camp, save\nthat Captain Blunt and lieutenants passed about, examining\nall the guns and asking if powder-horns were\nfull. But at the breaking of camp, in the dawn, when\nthe wagons were forming to pull out in the double-column,"), _c('span', {
    attrs: {
      "id": "pgepubid00024",
      "title": "[28]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_28",
      "title": "[28]"
    }
  })]), _vm._v("\nsomething very especial happened. Behold,\ninto every wagon climbed a trapper or two, and stowed\nthemselves safely away amidst the goods under the protective\ncanvas hoods! Just a corner of the canvas\nwas left looped up a few inches, as if for air.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("Now throughout the caravan eddied a gale of jeer\nand derision and protest.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“This is the way they ride the trail with us, is it!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“These ain’t mountain-men; they’re gophers!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“Have we got to haul ’em an’ fight for ’em,\nboth?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("Even Kit Carson had disappeared, for cover. But\nno response was made by the trappers; Captain Blunt\nand his assistants bade the teamsters “Ketch up!”\nand straighten out, for the march; and two by two on\nrolled the wagons, the teamsters angry, the trappers\ncomfortably inside, and the trappers’ horses tethered\nto the end-gates.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("The action on the part of the trappers seemed as\nstrange to boy Oliver as it did to the teamsters. Was\nthat how Kit Carson men battled—by hiding behind\nother men, and by crawling under cover and making\nthe people they were pretending to defend fight outside?\nHumph! Maybe this wasn’t Kit Carson, after\nall.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("The sand-hills were increasing in number and extent;\ndusty and dry was the way but nobody could\ndrink, for it was against orders to drink out of the\ncasks, or to fill canteens except once a day. The “dry"), _c('span', {
    attrs: {
      "id": "pgepubid00025",
      "title": "[29]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_29",
      "title": "[29]"
    }
  })]), _vm._v("\nmarch” of over fifty miles was beginning, and sometimes\nwater gave out before it was traversed. So\nevery drop must be cherished.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("With the hot sun about two hours high the caravan\nwas entering upon a long, rather narrow swale leading\nbetween rounded sand-ridges whereon only cactus and\na few sprawly weeds grew. Captain Blunt and several\nother riders were in advance; out upon the right\nflank, and somewhat in advance rode Lieutenant Dan\nMatthews and two men, and similarly upon the left\nflank rode another wagon-train lieutenant. They\nclimbed hill after hill, and ridge after ridge, and surveyed\nclosely the country. As a rear-guard, behind\neven Oliver, rode a squad of half-a-dozen traders and\nfree-lances. Thus the caravan was apparently well\nprovided against surprise; and as evidently the Kiowas\nwere thought to be near at hand, the rear-guard gave\nOliver a more comfortable feeling.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("If the train must take care of itself, with those\ntrappers cravenly putting greater store on their own\nhides than on the purpose for which they had pretended\nto join, then the more precautions the better.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_c('span', {
    attrs: {
      "id": "pgepubid00026",
      "title": "[30]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_30",
      "title": "[30]"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5aaef08","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0007.vue
// module id = 75
// module chunks = 0